<template>
  <div
    class="t-search-field t-rounded"
    :style="`
      ${color?`background-color: ${color};`:''}
      ${border_color?`border-color: ${border_color};`:''}
      ${height?`height: ${height};`:''}
      ${width?`width: ${width};`:''}
      `"
    >
    <v-icon class="ml-1" :color="textcolor ? textcolor : 'rgba(255,255,255,0.9)'">search</v-icon>
    <input
      class="t-search-input"
      :value="value"
      :placeholder="placeholder"
      :style="textcolor ? textcolor : 'color: rgba(255,255,255,0.9);'"
      @input="inputEvent($event)"
      />
    <v-icon @click="$emit('cancel')" small class="mr-1 cursor-pointer" :color="textcolor ? textcolor : 'rgba(255,255,255,0.9)'">cancel</v-icon>
  </div>
</template>
<script>
  export default {
    props: ['value', 'color', 'border_color', 'height', 'textcolor', 'width', 'placeholder'],
    data: () => ({
      timer: null
    }),
    methods: {
      inputEvent(e){
        let self = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(function () {
          self.$emit('input', e);
        }, 1000);
      }
    }
  }
</script>
<style>
  .t-search-field {
    display: flex;
    border: solid 1px;
    height: 100%;
    width: 200px;
  }
  .t-search-input {
    width: 100%;
  }
  .t-search-input:focus {
    outline: none;
  }
</style>
